<div id="wrapper">

	<div id="search-container">
	    
	    <div id="search-wrapper">
	        <h1>Search</h1>
	        <app-item-search (selectItem)="selectSearchResult( $event )"></app-item-search>
	        <button [ngClass]="{ disabled: !skuToConfigure }" 
	           [disabled]="!skuToConfigure"
	           (click)="configure()">Configure</button>
	    </div>
	    
	    <!-- <div id="trending-wrapper">
	        <h1>Trending</h1>
	    </div>    --> 
	        
	</div>
	
	<div id="browse-container">
	    
	    <h1>Browse</h1>
	    <select id="brand-select" [(ngModel)]="homeService.brandId" (change)="updateBrandItems()">
	        <option *ngFor="let brand of brands" [value]="brand.id">{{ brand.name }}</option>
	    </select>
	    <div id="filters">
	        
	        <div id="device-type-filters">
	            
	            <span [ngClass]="{ selected: homeService.deviceType === filter }" class="filter" *ngFor="let filter of getDeviceFilters()" 
	                (click)="setDeviceFilter(filter)">{{ filter }}</span>
	            
	        </div>
	        
	        <div *ngIf="homeService.deviceType" id="filter-groups">
	            <span [ngClass]="{ selected: homeService.filterGroups[0] === filter }" class="filter" *ngFor="let filter of getFilterGroups()" 
	                (click)="setFilterGroup(filter)">{{ filter }}</span>
	        </div>
	        
	    </div>
	    <div class="brand-items">
	        <div class="generation-wrap clearfix" *ngIf="!!getFilteredCurrentItems().length">
		        <h2 class="generation-header">Current</h2>
		        <div class="item" *ngFor="let item of getFilteredCurrentItems()">
		            <a (click)="configure( item.sku )">{{ item.description }}</a>
		        </div>
	        </div>
	        <div class="generation-wrap clearfix" *ngIf="!!getFilteredPreviousItems().length">
                <h2 class="generation-header">Previous</h2>
                <div class="item" *ngFor="let item of getFilteredPreviousItems()">
                    <a (click)="configure( item.sku )">{{ item.description }}</a>
                </div>
            </div>
	    </div>
	
	</div>

</div>